import { Navigate, createFileRoute } from '@tanstack/react-router'
import { EmptyState } from '~/elements'
import { listWorkspaceIntegrationsQueryOptions } from '~/queries'
import { Box } from 'lucide-react'
import { cn } from '~/utils'
import { useSuspenseQuery } from '@tanstack/react-query'
import { Card, Separator } from '@bpinternal/ui-kit-next'
import { config } from '~/shared'
import { Page } from '~/components'

export const Route = createFileRoute('/workspaces/$workspaceId/integrations/')({
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(listWorkspaceIntegrationsQueryOptions({ workspaceId: params.workspaceId })),
  component: Component,
})

function Component() {
  const { workspaceId } = Route.useParams()
  const [firstIntegration] = useSuspenseQuery(listWorkspaceIntegrationsQueryOptions({ workspaceId })).data

  return firstIntegration ? (
    <Navigate
      to="/workspaces/$workspaceId/integrations/$integrationId"
      replace
      params={{ workspaceId, integrationId: firstIntegration.id }}
    />
  ) : (
    <EmptyIntegrations />
  )
}

const EmptyIntegrations = () => {
  return (
    <Page title="Integrations">
      <Card className="mx-auto py-10 sm:w-4/5">
        <EmptyState
          icon={({ className, ...props }) => (
            <Box strokeWidth="0.9" className={cn('text-accent-10', className)} {...props} />
          )}
          iconSize={5}
          title="You own no integrations"
          description="Integrations connect Botpress to other services. What do you want to do from here?"
        />
        <div className="mx-auto mt-8 flex items-center justify-center gap-8">
          <div className="flex flex-col items-center">
            <p className="mb-1 text-sm text-gray-11">Looking for an integration</p>
            <a
              className="text-sm text-primary underline-offset-4 hover:underline"
              href={`${config.studioBaseUrl}?exploreHub=1`}
              target="_blank"
              rel="noopener noreferrer"
            >
              Search the Botpress Hub
            </a>
          </div>
          <Separator orientation="vertical" className="absolute left-1/2 h-10" />
          <div className="flex flex-col items-center">
            <p className="mb-1 text-sm text-gray-11">Build your own integration</p>
            <a
              className="text-sm text-primary underline-offset-4 hover:underline"
              href="https://botpress.com/docs/developers/howTo/build-integration"
              target="_blank"
              rel="noopener noreferrer"
            >
              Developer documentation
            </a>
          </div>
        </div>
      </Card>
    </Page>
  )
}
